import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from '../icons';

import "../../styles/chapter3/playlist_navi.scss";

class PlaylistNavi extends React.Component{


	constructor(props){
		super(props);

	}


	render(){

		return (<div className={"playlist-navi-holder open-" + this.props.naviOpen + " blended-"+this.props.showSongIntro}>
			<div className="playlist-navi-background">
				<div className="playlist-navi-inner">
							<div className="song-navi-inner">
								{(this.props.index - 1) >= 0 && 
									<button onClick={()=>this.props.changeSongToIndex(this.props.index - 1)} className="song-navi-prev"><Iconset.playlist_arrow_left /></button>
								}
								<button onClick={()=>this.props.toggleNavi(!this.props.naviOpen)} className={"playlist-song-selector-open playlist-song-selector-open-mode-" + this.props.naviOpen}><span className="playlist-song-selector-text">Tracklist</span></button>
							
									{(this.props.index + 1 < this.props.songs.length) && this.props.songs[this.props.index + 1].active && 
										<button onClick={()=>this.props.changeSongToIndex(this.props.index + 1)} className="song-navi-next"><Iconset.playlist_arrow_right /></button>
									}
								
							</div>
				
					{this.props.naviOpen && 
						<nav>
							{/*first half*/}
							<div className="nav-side">
								{this.props.songs.map((song,index)=>{
									
										if(song.active){
											let selectedBool = false;
											if(index == this.props.index){
												selectedBool = true;
											}
											return (<button onClick={()=>this.props.changeSongToIndex(index)} className={"playlist-song-selector active selected-" + selectedBool}>{song.title}{song.feat && " " + song.feat}</button>);
										}else{
											return (<button className="playlist-song-selector inactive" disabled><span className="playlist-song-selector-title">{song.title}{song.feat && " " + song.feat}</span><span className="playlist-song-selector-release-date">{song.release}{song.release_end} March</span></button>);
										}
									
								})}
							</div>
					
						</nav>
					}
					</div>
				</div>
		</div>);
	}
}

export default PlaylistNavi;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/playlist_navi.js